import moment from "moment";
import { ValueGetterParams } from "ag-grid-community";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { UnusedSince } from "@/services/cloudchipr.api";

export const unusedSinceDurationValueGetter = ({ data }: ValueGetterParams) => {
  const unusedSince = data?.resource?.unused_since as UnusedSince;

  if (unusedSince?.is_used || !unusedSince?.timestamp) {
    return "No data";
  }

  const formattedData = moment(formatDate(unusedSince?.timestamp));

  const fromNow = moment().diff(formattedData, "hours");

  const durationAsDays =
    Math.abs(fromNow) > 23
      ? moment.duration(-Math.abs(fromNow), "hours").humanize(true, {
          h: 0,
        })
      : "";

  const titleDate = `${formatDate(formattedData, {
    type: "date",
  })}`;

  return durationAsDays
    ? `${durationAsDays} (${titleDate})`
    : "Less than a day";
};
